exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Variables */\n\n/* Mixins */\n.approval-count {\n  font-size: 60px;\n  margin: auto;\n  text-align: center;\n  font-family: \"Courier New\", Courier, monospace;\n  font-weight: bold;\n}\n.approval-label {\n  margin: auto;\n  text-align: center;\n  font-weight: 200;\n}\n.column-approval {\n  border: 1px solid gray;\n  border-radius: 5px;\n  padding: 10px;\n}", ""]);

// Exports
exports.locals = {
	"menuBg": "#304156",
	"menuText": "#bfcbd9",
	"menuActiveText": "#efefef"
};